import { REDO_RINGTONE } from "../../sound/sounds";
import { getRingtoneVolume, outputVolumeToAudioLevel } from "./utils";

export function updateRingtoneVolume(): void {
  REDO_RINGTONE.volume = outputVolumeToAudioLevel(getRingtoneVolume());
}
